// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"b0512970","194":"746f7290","212":"8a11cdbe","233":"23999d4a","289":"2e50436b","291":"78d5bd28","337":"730f710b","433":"7a0a20fd","480":"a7c060e0","719":"36060130","786":"142d9fd2","866":"a4774c24","912":"d82e1f5f","916":"d6cccae2"}[chunkId] + ".chunk.js";
};